export default "__VITE_ASSET__5745293e__"